import { normalizeSelectValue } from '../../model/normalize-select-value';
import { OptionType } from '../../model/types';
import { useWarrantyTypes } from 'entities/warranty';
import { FC, useEffect, useMemo } from 'react';
import { Select } from 'shared';

type Props = {
  placeholder?: string;
  warrantyTypeIds?: number[];
  onChange: (warrantyTypeIds?: number[]) => void;
  isClearable: boolean;
  isMulti: boolean;
};

export const SelectWarrantyType: FC<Props> = ({ placeholder, warrantyTypeIds, onChange, isClearable, isMulti }) => {
  const { data, isFetching } = useWarrantyTypes();

  const options: OptionType[] = useMemo(() => {
    return (
      data
        ?.filter((x) => x.id && x.name)
        .map((x) => ({
          value: x.id?.toString()!,
          label: x.name!
        })) ?? []
    );
  }, [data]);

  const selectedIds = warrantyTypeIds ?? [];

  const selectedOptions: OptionType[] = useMemo(() => {
    return options.filter((o) => selectedIds.includes(Number(o.value)));
  }, [options, selectedIds]);

  useEffect(() => {
    if (!isFetching && !isMulti && !isClearable && options.length > 0 && selectedIds.length === 0) {
      onChange([Number(options[0].value)]);
    }
  }, [isFetching, isMulti, isClearable, options, selectedIds.length, onChange]);

  return (
    <Select
      isMulti={isMulti}
      options={options}
      value={selectedOptions}
      onChange={(val) => onChange(normalizeSelectValue(val, isMulti))}
      placeholder={isFetching ? 'Please wait...' : placeholder ?? ''}
      isClearable={isClearable}
      isDisabled={isFetching}
      instanceId={`WarrantyType-select`}
      highlightSelected
      isSolid
    />
  );
};
